import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { CountryView } from "./CountryView";
import { CountryViewStore } from "../../store/CountryViewStore";
import { useStore } from "../../../../hooks";

export const CountryViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/country/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new CountryViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <CountryView countryViewStore={store} />
      </PageLayout>
    </div>
  );
});
